const facilityCategoriesPath = '/facilities/categories';
export const getFacilityCategories = facilityCategoriesPath;
export const getFacilityCategoryById = (id: number) => `${facilityCategoriesPath}/${id}`;
export const createFacilityCategory = facilityCategoriesPath;
export const updateFacilityCategory = (id: number) => `${facilityCategoriesPath}/${id}`;
export const updateFacilityCategoryStatus = (id: number) => `${facilityCategoriesPath}/${id}/publishing`;
